import reduceReducers from 'reduce-reducers';

//Siblings reducers
import positionReducer from './positionReducer';

export default reduceReducers(positionReducer);
